import { Component, Inject } from '@angular/core';
import { NavigationEnd, Route, Router } from '@angular/router';
import * as constant from '../shared/constants/constants'
import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { NavigationService } from '../shared/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../shared/services/api.service';
import { StorageService } from '../shared/services/storage.service';
import { localStorageKeys } from '../core/enum';
import { UtilService } from '../shared/services/util.service';
import { UrlSecurityService } from '../shared/services/url-security.service';

@Component({
  selector: 'app-costa',
  templateUrl: './costa.component.html',
  styleUrls: ['./costa.component.scss']
})
export class CostaComponent {
  /** to show nav bar only when the username is set */
  show_navbar: boolean = false;
  user_details : any;

  constructor(
    private router: Router,
    @Inject(MSAL_INSTANCE) private msalInstance: IPublicClientApplication,
    public navigationService: NavigationService,
    private apiService: ApiService,
    private storageService: StorageService,
    private utilService : UtilService,
    private urlService: UrlSecurityService
  ) {
    this.getMarket();
    this.getApiKeys();
  }

   async getMarket(){
    await this.utilService.setMarketValue();
    this.utilService.market_trigger.subscribe((value)=>{
      if(value){
        this.show_navbar = true;
        this.getUserDetails();
      }
      else{
        this.router.navigate(['/'])
      }
    })
  }

  ngOnInit(): void {
    // this.accountCheckAndRedirect();
  }

  /** Get Api Keys From Service */
  getApiKeys(){
    this.apiService.getApiKeys().subscribe({
      next: async (response: any) => {
        this.handleApiKeys(response);
      },
      error: (error: any) => {
        this.utilService.logout();
      }
    })
  }

  /** To Handle ApiKeys Response */
  async handleApiKeys(response:any){
    sessionStorage.setItem(constant.storage_keys.api_keys, JSON.stringify(response))
    await this.urlService.addSecurityKeys();
    this.addMapKey();
  }

  /** To Add Map Key to the DOM */
  async addMapKey(){
    let API_KEYS:any = await sessionStorage.getItem(constant.storage_keys.api_keys)
    API_KEYS = JSON.parse(API_KEYS)
    if (API_KEYS.uuid_8) {
      this.utilService.marketArray = API_KEYS.uuid_8
    }
    this.storageService.set(constant.storage_keys.user_name, API_KEYS.name);
    this.storageService.set(constant.storage_keys.role_id, API_KEYS.role_id);
    this.utilService.key_trigger.next(true)
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.src = constant.common.gmap_url+API_KEYS.uuid_5+"&loading=async";
    body.appendChild(script);
  }

  /** Get User Details From Service */
  async getUserDetails(){
      this.apiService.getUserDetails().subscribe({
        next: async (response: any) => {
          this.handleUserDetails(response);
        },
        error: (error: any) => {
          this.utilService.logout();
        }
      })
  }

  /** Handle User Details*/
  handleUserDetails(response: any) {
    this.user_details = response.name;
    this.storageService.set(constant.storage_keys.user_name, response.name);
    this.storageService.set(constant.storage_keys.role_id, response.role_id);
    this.utilService.role_id_trigger.next(response.role_id)
    this.roleBasedFeaturesDto()
  }

  /** DTO for Role Base Permission */
  async roleBasedFeaturesDto() {
    const role_id = await this.storageService.get(constant.storage_keys.role_id)
    const payload = {
      role_id: role_id
    }
    this.getRoleBasedFeatures(payload)
  }

  /** Api Call Role Based Permission */
  getRoleBasedFeatures(payload: any) {
    this.apiService.getRoleBasedFeatures(payload).subscribe((response: any) => {
      this.storageService.set(localStorageKeys.features_available, response.feature_available)
      this.utilService.getFeatures();
    })
  }

  /** Check the account and redirect to the dashboard */
  accountCheckAndRedirect() {
    if (this.msalInstance.getAllAccounts().length > constant.common.zero) {
      this.router.navigate([constant.navigation.dashboard]);
    }
  }
}
